import React from "react";
import { date, formatDate } from "../../../utilities/utils";

const DisplayEmployeeBlock = ({ state, context }) => {
  return (
    <div className="Search-result">
      <div className="row">
        <div className="col-6">
          <div className="result-label">
            <b>
              {context.t(
                "STD-Employer-Statement.form.Employee-Details.label.text.EEName"
              )}
              :-
            </b>
            {state.employeeFirstName.value ? state.employeeFirstName.value : ""}&nbsp;
            {state.employeeLastName.value ? state.employeeLastName.value : ""}
          </div>
        </div>

        <div className="col-6 result-label">
          <b>
            {context.t(
              "STD-Employer-Statement.form.label.text.Employee-ID/EIN"
            )}
            :-
          </b>
          {state.employee.value ? state.employee.value : ""}
        </div>
      </div>
    </div>
  );
};
export default DisplayEmployeeBlock;
